<template>
  <div id="mallset">
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div>
        <div
          class="br-pagetitle d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <i class="icon ion-bag"></i>
            <div class="mg-l-20">
              <h4>{{ $t("mall.商城站点设置") }}</h4>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card mg-x-50 pd-20 mg-y-20 card-subuser"
        v-if="isSysRights('SupplierMallConfig.addConfig')"
      >
        <form>
          <div class="row align-items-center form-group">
            <label class="col-form-label form-control-sm text-right tx-white"
              >&emsp;&emsp;{{ $t("mall.店铺名称") }}</label
            >
            <div class="col-md-10 col-sm-12 d-flex align-items-center tx-white">
              <template v-if="!editName">
                <span class="mg-r-5">{{
                  configInfo.mallName ? configInfo.mallName : $t("mall.暂无")
                }}</span>
                <a
                  v-if="configInfo.mallName"
                  class="to-clipboard"
                  href="javascript:;"
                  :data-clipboard-text="configInfo.mallName"
                >
                  <i class="icon ion-clipboard"></i>
                </a>
                <a
                  href="javascript:;"
                  class="tx-info mg-l-20"
                  @click="edit('name')"
                  ><i class="icon ion-edit"></i
                ></a>
              </template>
              <template v-if="editName">
                <input
                  v-model="configInfo.mallName"
                  class="form-control form-control-sm tx-13 mg-r-20 wd-600"
                  :placeholder="$t('mall.店铺名称')"
                />
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-primary mg-r-10 tx-12"
                  @click="editSave('name')"
                  >{{ $t("mall.保存") }}</a
                >
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-secondary tx-12"
                  @click="editCancel('name')"
                  >{{ $t("mall.取消") }}</a
                >
              </template>
            </div>
          </div>
          <div class="row align-items-center form-group">
            <label class="col-form-label form-control-sm text-right tx-white"
              >&emsp;&emsp;ICP{{ $t("mall.备案：") }}</label
            >
            <div class="col-md-10 col-sm-12 d-flex align-items-center tx-white">
              <template v-if="!editIpc">
                <span v-if="!configInfo.ipcRecord" class="mg-r-5">{{
                  $t("mall.暂无")
                }}</span>
                <span v-if="configInfo.ipcRecord" class="mg-r-5">{{
                  configInfo.ipcRecord
                }}</span>
                <a
                  v-if="configInfo.ipcRecord"
                  class="to-clipboard"
                  href="javascript:;"
                  :data-clipboard-text="configInfo.ipcRecord"
                >
                  <i class="icon ion-clipboard"></i>
                </a>
                <a
                  href="javascript:;"
                  class="tx-info mg-l-20"
                  @click="edit('ipc')"
                  ><i class="icon ion-edit"></i
                ></a>
              </template>
              <template v-if="editIpc">
                <input
                  v-model="configInfo.ipcRecord"
                  class="form-control form-control-sm tx-13 mg-r-20 wd-600"
                  :placeholder="$t('mall.ICP备案')"
                />
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-primary mg-r-10 tx-12"
                  @click="editSave('ipc')"
                  >{{ $t("mall.保存") }}</a
                >
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-secondary tx-12"
                  @click="editCancel('ipc')"
                  >{{ $t("mall.取消") }}</a
                >
              </template>
            </div>
          </div>
          <div class="row align-items-center form-group">
            <label class="col-form-label form-control-sm text-right tx-white"
              >&emsp;&emsp;{{ $t("mall.公安备案：") }}</label
            >
            <div class="col-md-10 col-sm-12 d-flex align-items-center tx-white">
              <template v-if="!editPolice">
                <span v-if="!configInfo.policeRecord" class="mg-r-5">{{
                  $t("mall.暂无")
                }}</span>
                <span v-if="configInfo.policeRecord" class="mg-r-5">{{
                  configInfo.policeRecord
                }}</span>
                <a
                  v-if="configInfo.policeRecord"
                  class="to-clipboard"
                  href="javascript:;"
                  :data-clipboard-text="configInfo.policeRecord"
                >
                  <i class="icon ion-clipboard"></i>
                </a>
                <a
                  href="javascript:;"
                  class="tx-info mg-l-20"
                  @click="edit('police')"
                  ><i class="icon ion-edit"></i
                ></a>
              </template>
              <template v-if="editPolice">
                <input
                  v-model="configInfo.policeRecord"
                  class="form-control form-control-sm tx-13 mg-r-20 wd-600"
                  :placeholder="$t('mall.公安备案')"
                />
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-primary mg-r-10 tx-12"
                  @click="editSave('police')"
                  >{{ $t("mall.保存") }}</a
                >
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-secondary tx-12"
                  @click="editCancel('police')"
                  >{{ $t("mall.取消") }}</a
                >
              </template>
            </div>
          </div>
          <div class="row align-items-start form-group">
            <label
              class="col-form-label form-control-sm text-right tx-white pd-t-0"
              >&emsp;&emsp;{{ $t("mall.站点域名：") }}</label
            >
            <div class="col-md-10 col-sm-12 tx-white">
              <div
                class="d-flex align-items-center mg-b-10"
                v-for="(site, i) in (configInfo || {}).webSiteJsonSet"
                :key="i"
              >
                <template v-if="!site.edit">
                  <a
                    :href="'//' + site.name"
                    target="_blank"
                    class="tx-info mg-r-5"
                    >{{ site.name }}</a
                  >
                  <a
                    v-if="site.name"
                    class="to-clipboard mg-l-15"
                    href="javascript:;"
                    :data-clipboard-text="site.name"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                  <a
                    v-if="i > 0"
                    href="javascript:;"
                    class="tx-info mg-l-20"
                    @click="edit('site', i)"
                    ><i class="icon ion-edit"></i
                  ></a>
                  <a
                    v-if="i > 0"
                    href="javascript:;"
                    class="tx-danger mg-l-20"
                    @click="remove('site', i)"
                    ><i class="icon ion-close"></i
                  ></a>
                </template>
                <template v-if="site.edit">
                  <input
                    v-model="site.name"
                    class="form-control form-control-sm tx-13 mg-r-20 wd-600"
                    :placeholder="$t('mall.站点域名')"
                  />
                  <a
                    href="javascript:;"
                    class="btn btn-sm btn-primary mg-r-10 tx-12"
                    @click="editSave('site', i)"
                    >{{ $t("mall.保存") }}</a
                  >
                  <a
                    href="javascript:;"
                    class="btn btn-sm btn-secondary tx-12"
                    @click="editCancel('site', i)"
                    >{{ $t("mall.取消") }}</a
                  >
                </template>
              </div>
              <div class="">
                <a
                  href="javascript:;"
                  class="tx-info"
                  @click="addNewSite('site')"
                  >{{ $t("mall.添加新域名") }}</a
                >
              </div>
              <div class="d-flex align-items-center mg-t-15">
                {{ $t("mall.开放用户注册") }}
                <a
                  style="height: 26px"
                  href="javascript:;"
                  class="toggle-wrapper mg-l-15"
                  @click="editSave('toggle')"
                  :class="{ toggles_on: configInfo.openRegister == 1 }"
                >
                  <div class="toggle toggle-light primary">
                    <div class="toggle-slide">
                      <div class="toggle-inner">
                        <div class="toggle-on">{{ $t("mall.是") }}</div>
                        <div class="toggle-blob"></div>
                        <div class="toggle-off">{{ $t("mall.否") }}</div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="row align-items-start form-group">
            <label
              class="
                col-form-label
                form-control-sm
                text-right
                tx-white
                mg-l-5
                pd-t-0
              "
              >&emsp;&emsp;{{ $t("mall.客服QQ：") }}</label
            >
            <div class="col-md-10 col-sm-12 tx-white">
              <div
                class="d-flex align-items-center mg-b-10"
                v-for="(site, i) in (configInfo || {}).serviceJsonSet"
                :key="i"
              >
                <template v-if="!site.edit">
                  <span class="tx-white mg-r-5">{{ site.name }}:</span>
                  <a
                    v-if="site.value"
                    target="_blank"
                    :href="
                      'tencent://message/?uin=' +
                      site.value +
                      '&Site=5yoho&Menu=yes'
                    "
                    class="qq-link tx-info mg-r-5"
                    >{{ site.value }}</a
                  >
                  <span v-else>{{ $t("mall.暂无") }}</span>
                  <a
                    v-if="site.value"
                    class="to-clipboard mg-l-15"
                    href="javascript:;"
                    :data-clipboard-text="site.value"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="tx-info mg-l-20"
                    @click="edit('qq', i)"
                    ><i class="icon ion-edit"></i
                  ></a>
                  <a
                    href="javascript:;"
                    class="tx-danger mg-l-20"
                    @click="remove('qq', i)"
                    ><i class="icon ion-close"></i
                  ></a>
                </template>
                <template v-if="site.edit">
                  <input
                    v-model="site.name"
                    class="form-control form-control-sm tx-13 mg-r-20 wd-200"
                    :placeholder="$t('mall.QQ名字')"
                  />
                  <input
                    v-model="site.value"
                    class="form-control form-control-sm tx-13 mg-r-20 wd-400"
                    :placeholder="$t('mall.客服QQ')"
                  />
                  <a
                    href="javascript:;"
                    class="btn btn-sm btn-primary mg-r-10 tx-12"
                    @click="editSave('qq', i)"
                    >{{ $t("mall.保存") }}</a
                  >
                  <a
                    href="javascript:;"
                    class="btn btn-sm btn-secondary tx-12"
                    @click="editCancel('qq', i)"
                    >{{ $t("mall.取消") }}</a
                  >
                </template>
              </div>
              <div class="">
                <a href="javascript:;" class="tx-info" @click="addNewSite('qq')"
                  >{{ $t("mall.添加新") }}QQ</a
                >
              </div>
            </div>
          </div>
          <div class="row align-items-start form-group">
            <label
              class="col-form-label form-control-sm text-right tx-white pd-t-0"
              >&emsp;&emsp;{{ $t("mall.联系信息：") }}</label
            >
            <div class="col-md-10 col-sm-12 d-block tx-white">
              <div class="d-flex align-items-center mg-b-15">
                <div class="d-flex align-items-center wd-300">
                  <template v-if="!editContact">
                    <span class="mg-r-5"
                      >{{ $t("mall.联系人：")
                      }}{{ contact ? contact : $t("mall.暂无") }}</span
                    >
                    <a
                      v-if="contact"
                      class="to-clipboard mg-l-15"
                      href="javascript:;"
                      :data-clipboard-text="contact"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </template>
                  <template v-if="editContact">
                    <input
                      v-model="contact"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-300"
                      :placeholder="$t('mall.联系人')"
                    />
                  </template>
                </div>
                <div class="d-flex align-items-center wd-500">
                  <template v-if="!editContact">
                    <span class="mg-r-5"
                      >{{ $t("mall.手机：")
                      }}{{ mobile ? mobile : $t("mall.暂无") }}</span
                    >
                    <a
                      v-if="mobile"
                      class="to-clipboard mg-l-15"
                      href="javascript:;"
                      :data-clipboard-text="mobile"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="tx-info mg-l-15"
                      @click="edit('contact')"
                      ><i class="icon ion-edit"></i
                    ></a>
                  </template>
                  <template v-if="editContact">
                    <input
                      v-model="mobile"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-300"
                      :placeholder="$t('mall.手机')"
                    />
                    <a
                      href="javascript:;"
                      class="btn btn-sm btn-primary mg-r-10 tx-12"
                      @click="editSave('contact')"
                      >{{ $t("mall.保存") }}</a
                    >
                    <a
                      href="javascript:;"
                      class="btn btn-sm btn-secondary tx-12"
                      @click="editCancel('contact')"
                      >{{ $t("mall.取消") }}</a
                    >
                  </template>
                </div>
              </div>
              <div class="d-flex align-items-center mg-b-15">
                <div class="d-flex align-items-center wd-300">
                  <template v-if="!editContact">
                    <span class="mg-r-5"
                      >Q&emsp;Q：
                      <a
                        v-if="qq != ''"
                        target="_blank"
                        :href="
                          'tencent://message/?uin=' +
                          qq +
                          '&Site=5yoho&Menu=yes'
                        "
                        class="qq-link tx-info"
                        >{{ qq }}</a
                      >
                      <span v-else>{{ $t("mall.暂无") }}</span>
                    </span>
                    <a
                      v-if="qq"
                      class="to-clipboard mg-l-15"
                      href="javascript:;"
                      :data-clipboard-text="qq"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </template>
                  <template v-if="editContact">
                    <input
                      v-model="qq"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-300"
                      placeholder="QQ"
                    />
                  </template>
                </div>
                <div class="d-flex align-items-center wd-300">
                  <template v-if="!editContact">
                    <span class="mg-r-5"
                      >{{ $t("mall.旺旺：") }}
                      <a
                        v-if="wangwang != ''"
                        class="tx-info"
                        target="_blank"
                        :href="
                          'http://amos.alicdn.com/msg.aw?v=2&uid=' +
                          wangwang +
                          '&site=cnalichn&s=11&charset=UTF-8'
                        "
                        >{{ wangwang }}</a
                      >
                      <span v-else>{{ $t("mall.暂无") }}</span>
                    </span>
                    <a
                      v-if="wangwang"
                      class="to-clipboard mg-l-15"
                      href="javascript:;"
                      :data-clipboard-text="wangwang"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </template>
                  <template v-if="editContact">
                    <input
                      v-model="wangwang"
                      class="form-control form-control-sm tx-13 mg-r-0 wd-300"
                      :placeholder="$t('mall.旺旺')"
                    />
                  </template>
                </div>
              </div>
              <div class="d-flex align-items-center mg-b-15">
                <div class="d-flex align-items-center">
                  <template v-if="!editContact">
                    <span
                      >{{ $t("mall.地 址：") }}
                      <span v-if="configInfo.contactJson">
                        {{
                          configInfo.contactJson.province
                            ? configInfo.contactJson.province
                            : ""
                        }}
                        {{
                          configInfo.contactJson.city
                            ? configInfo.contactJson.city
                            : ""
                        }}
                        {{
                          configInfo.contactJson.area
                            ? configInfo.contactJson.area
                            : ""
                        }}
                        {{
                          configInfo.contactJson.address
                            ? configInfo.contactJson.address
                            : ""
                        }}
                      </span>
                      <span v-else>{{ $t("mall.暂无") }}</span>
                    </span>
                  </template>
                  <template v-if="editContact">
                    <div class="col wd-150 pd-l-0">
                      <select
                        class="form-control form-control-sm"
                        @change="selectProvince()"
                        v-model="province"
                        name="addressProvince"
                      >
                        <option
                          v-for="(province, index) in selectCityArr"
                          :key="index"
                          v-text="province.name"
                          :value="index"
                        ></option>
                      </select>
                    </div>
                    <div class="col wd-150">
                      <select
                        class="form-control form-control-sm"
                        @change="selectCity()"
                        v-model="city"
                        :disabled="cityArr.length < 1"
                        name="addressCity"
                      >
                        <option
                          v-for="(city, index) in cityArr"
                          :key="index"
                          v-text="city.name"
                          :value="index"
                        ></option>
                      </select>
                    </div>
                    <div class="col wd-150">
                      <select
                        class="form-control form-control-sm"
                        v-model="area"
                        :disabled="areaArr.length < 1"
                        name="addressArea"
                      >
                        <option
                          v-for="(area, index) in areaArr"
                          :key="index"
                          v-text="area.name"
                          :value="index"
                        ></option>
                      </select>
                    </div>
                    <input
                      v-model="address"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-300"
                      :placeholder="$t('mall.地址')"
                    />
                  </template>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <template v-if="!editContact">
                    <span
                      >{{ $t("mall.邮 编：") }}
                      <span v-if="configInfo.contactJson">
                        {{
                          configInfo.contactJson.postCode
                            ? configInfo.contactJson.postCode
                            : ""
                        }}
                      </span>
                      <span v-else>{{ $t("mall.暂无") }}</span>
                    </span>
                  </template>
                  <template v-if="editContact">
                    <input
                      v-model="postCode"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-300"
                      :placeholder="$t('mall.邮编')"
                    />
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row align-items-start form-group"
            v-if="userInfo.isOpenCusMall == 1"
          >
            <label
              class="col-form-label form-control-sm text-right tx-white pd-t-0"
              >&emsp;&emsp;{{ $t("mall.收款方式：") }}</label
            >
            <div class="col-md-10 col-sm-12 tx-white">
              <div
                class="mg-b-10"
                v-if="configInfo.paymentJson && configInfo.paymentJson.Z"
              >
                <template v-if="!configInfo.paymentJson.Z.edit">
                  <span class="tx-white mg-r-5"
                    >{{ $t("mall.支付宝") }}：{{
                      configInfo.paymentJson.Z.appId
                        ? configInfo.paymentJson.Z.appId
                        : $t("mall.暂无")
                    }}</span
                  >
                  <a
                    v-if="configInfo.paymentJson.Z.appId"
                    class="to-clipboard mg-l-15"
                    href="javascript:;"
                    :data-clipboard-text="configInfo.paymentJson.Z.appId"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="tx-info mg-l-20"
                    @click="edit('payZ')"
                    ><i class="icon ion-edit"></i
                  ></a>
                </template>
                <template v-if="configInfo.paymentJson.Z.edit">
                  <div class="mg-b-10 d-flex align-items-center">
                    <span>{{ $t("mall.支付宝appId：") }}</span>
                    <input
                      v-model="configInfo.paymentJson.Z.appId"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-400"
                      :placeholder="$t('mall.支付宝appId')"
                    />
                  </div>
                  <div class="mg-b-10 d-flex align-items-center">
                    <span style="margin-right: 8px">{{
                      $t("mall.支付宝私钥：")
                    }}</span>
                    <input
                      v-model="configInfo.paymentJson.Z.privateKey"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-400"
                      :placeholder="$t('mall.支付宝私钥')"
                    />
                  </div>
                  <div class="mg-b-15 d-flex align-items-center">
                    <span style="margin-right: 8px">{{
                      $t("mall.支付宝公钥：")
                    }}</span>
                    <input
                      v-model="configInfo.paymentJson.Z.publicKey"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-400"
                      :placeholder="$t('mall.支付宝公钥')"
                    />
                  </div>
                  <a
                    href="javascript:;"
                    class="btn btn-sm btn-primary mg-r-10 tx-12"
                    @click="editSave('payZ')"
                    >{{ $t("mall.保存") }}</a
                  >
                  <a
                    href="javascript:;"
                    class="btn btn-sm btn-secondary tx-12"
                    @click="editCancel('payZ')"
                    >{{ $t("mall.取消") }}</a
                  >
                </template>
              </div>
              <div
                class="mg-b-10"
                v-if="configInfo.paymentJson && configInfo.paymentJson.W"
              >
                <template v-if="!configInfo.paymentJson.W.edit">
                  <span class="tx-white mg-r-5"
                    >{{ $t("mall.微 信：")
                    }}{{
                      configInfo.paymentJson.W.appId
                        ? configInfo.paymentJson.W.appId
                        : $t("mall.暂无")
                    }}</span
                  >
                  <a
                    v-if="configInfo.paymentJson.W.appId"
                    class="to-clipboard mg-l-15"
                    href="javascript:;"
                    :data-clipboard-text="configInfo.paymentJson.W.appId"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="tx-info mg-l-20"
                    @click="edit('payW')"
                    ><i class="icon ion-edit"></i
                  ></a>
                </template>
                <template v-if="configInfo.paymentJson.W.edit">
                  <div class="mg-b-10 d-flex align-items-center">
                    <span>{{ $t("mall.微信appId：") }}</span>
                    <input
                      v-model="configInfo.paymentJson.W.appId"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-400"
                      :placeholder="$t('mall.微信appId')"
                    />
                  </div>
                  <div class="mg-b-10 d-flex align-items-center">
                    <span>{{ $t("mall.微信商户id：") }}</span>
                    <input
                      v-model="configInfo.paymentJson.W.merchantId"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-400"
                      :placeholder="$t('mall.微信商户id')"
                    />
                  </div>
                  <div class="mg-b-10 d-flex align-items-center">
                    <span>{{ $t("mall.微信API密钥：") }}</span>
                    <input
                      v-model="configInfo.paymentJson.W.appKey"
                      class="form-control form-control-sm tx-13 mg-r-20 wd-400"
                      :placeholder="$t('mall.API密钥')"
                    />
                  </div>
                  <div class="mg-b-10 d-flex align-items-center">
                    <span>{{ $t("mall.微信支付appclient_cert.pem：") }}</span>
                    <span
                      v-if="configInfo.paymentJson.W.certUrl == 1"
                      class="tx-success mg-x-10"
                      >{{ $t("mall.已上传") }}</span
                    >
                    <label
                      class="custom-file form-control-sm d-block wd-400"
                      style="height: auto"
                    >
                      <input
                        v-if="show"
                        :placeholder="$t('mall.请选择需要上传的导入文件')"
                        @change="fileUpload($event)"
                        type="file"
                        id="upload_product"
                      />
                      <span
                        style="background: #fff; border: 1px solid #ddd"
                        class="
                          custom-file-control custom-file-control-primary
                          form-control-sm
                          tx-ellipsis1
                        "
                        v-text="filePath"
                      ></span>
                    </label>
                  </div>
                  <div class="mg-b-15 d-flex align-items-center">
                    <span>{{ $t("mall.微信支付appclient_key.pem：") }}</span>
                    <span
                      v-if="configInfo.paymentJson.W.keyUrl == 1"
                      class="tx-success mg-x-10"
                      >{{ $t("mall.已上传") }}</span
                    >
                    <label
                      class="custom-file form-control-sm d-block wd-400"
                      style="height: auto"
                    >
                      <input
                        v-if="show1"
                        :placeholder="$t('mall.请选择需要上传的导入文件')"
                        @change="fileUpload1($event)"
                        type="file"
                        id="upload_product1"
                      />
                      <span
                        style="background: #fff; border: 1px solid #ddd"
                        class="
                          custom-file-control custom-file-control-primary
                          form-control-sm
                          tx-ellipsis1
                        "
                        v-text="filePath1"
                      ></span>
                    </label>
                  </div>
                  <a
                    href="javascript:;"
                    class="btn btn-sm btn-primary mg-r-10 tx-12"
                    @click="editSave('payW')"
                    >{{ $t("mall.保存") }}</a
                  >
                  <a
                    href="javascript:;"
                    class="btn btn-sm btn-secondary tx-12"
                    @click="editCancel('payW')"
                    >{{ $t("mall.取消") }}</a
                  >
                </template>
              </div>
            </div>
          </div>
          <div class="row align-items-start form-group">
            <label
              class="col-form-label form-control-sm text-right tx-white pd-t-0"
              >{{ $t("mall.可见客户范围：") }}</label
            >
            <div class="col-md-10 col-sm-12 d-flex align-items-center tx-white">
              <div class="list-wrap wd-100p">
                <div class="list-head d-flex mg-b-5">
                  <div class="c-6">{{ $t("mall.客户分组") }}</div>
                  <div
                    :class="userInfo.isOpenSupplierMall == 1 ? 'c-6' : 'c-8'"
                  >
                    {{ $t("mall.是否允许访问网站") }}
                  </div>
                  <div
                    :class="userInfo.isOpenSupplierMall == 1 ? 'c-6' : 'c-8'"
                  >
                    {{ $t("mall.是否允许下单") }}
                  </div>
                  <div class="c-6" v-if="userInfo.isOpenSupplierMall == 1">
                    {{ $t("mall.是否显示价格") }}
                  </div>
                </div>
                <div
                  class="list-body d-flex mg-b-5"
                  v-for="(member, i) in configInfo.memberJsonSet"
                  :key="i"
                >
                  <div class="c-6">
                    {{ member.name }}
                  </div>
                  <div
                    :class="userInfo.isOpenSupplierMall == 1 ? 'c-6' : 'c-8'"
                  >
                    <label class="ckbox mg-b-0">
                      <input
                        type="checkbox"
                        v-model="member.allowVisit"
                        @change="editSave('member')"
                      />
                      <span></span>
                    </label>
                  </div>
                  <div
                    :class="userInfo.isOpenSupplierMall == 1 ? 'c-6' : 'c-8'"
                  >
                    <label class="ckbox mg-b-0">
                      <input
                        type="checkbox"
                        v-model="member.allowBuy"
                        @change="editSave('member')"
                      />
                      <span></span>
                    </label>
                  </div>
                  <div class="c-6" v-if="userInfo.isOpenSupplierMall == 1">
                    <label class="ckbox mg-b-0">
                      <input
                        type="checkbox"
                        v-model="member.allowShowPrice"
                        @change="editSave('member')"
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
                <div class="list-body d-flex mg-b-5">
                  <div class="c-6">
                    <a
                      href="javascript:;"
                      class="tx-info"
                      @click="addNewGroup"
                      >{{ $t("mall.新增客户分组") }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <no-rights v-else></no-rights>
    </div>
    <api-loading :show="loading"></api-loading>
    <Modal
      :modalId="'modalGroup'"
      :home="false"
      :loading="modalGroup.loading"
      :size="'md'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("mall.新增客户分组") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div class="form-group row mg-b-10">
            <p class="col-12 mg-b-0">{{ $t("mall.选择要新增的客户分组") }}:</p>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <div v-for="(item, index) in groupLi" :key="index">
              <label class="c-checkbox-wrap">
                <input type="checkbox" :value="item.id" v-model="checkedArr" />
                <div class="c-checkbox">
                  <i class="ion-android-checkbox-blank"></i>
                  <span style="word-break: break-all">{{ item.name }}</span>
                </div>
              </label>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-30
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="editSave('memberAdd')"
            >
              {{ $t("mall.确定") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("mall.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@components/Modal";
export default {
  props: ["user_info", "white_style"],
  data() {
    return {
      // 左边栏状态
      leftSideStatus: true,
      loading: false,
      editName: false,
      name: "策划撕一下的我IE带为欧文我陪我温泉王企鹅无无",
      editPay: false,
      payment: "81598155@qq.com",
      configInfo: "",
      contact: "",
      mobile: "",
      qq: "",
      wangwang: "",
      editContact: false,
      serviceQQ: "19878498484",
      editSqq: false,
      province: 0,
      city: 0,
      area: "",
      address: "",
      postCode: "",
      selectCityArr: arrCity,
      cityArr: [],
      areaArr: [],
      groupLi: [],
      checkedArr: [],
      modalGroup: {
        loading: false,
      },
      configInfoCopy: "",
      editIpc: false,
      editPolice: false,
      show: true,
      fileObj: "",
      filePath: "",
      show1: true,
      fileObj1: "",
      filePath1: "",
      userInfo: userInfo,
    };
  },
  filters: {},
  created() {
    this.fileObj = "";
    this.filePath = "";
    this.show = false;
    this.fileObj1 = "";
    this.filePath1 = "";
    this.show1 = false;
    setTimeout(() => {
      this.show = true;
      this.show1 = true;
    }, 300);
    this.getConfig();
  },
  mounted() {},
  updated() {},
  computed: {
    editPayW() {
      return this.configInfo.paymentJson && this.configInfo.paymentJson.W
        ? this.configInfo.paymentJson.W.edit
        : false;
    },
  },
  watch: {
    editPayW() {
      this.fileObj = "";
      this.filePath = "";
      this.show = false;
      this.fileObj1 = "";
      this.filePath1 = "";
      this.show1 = false;
      setTimeout(() => {
        this.show = true;
        this.show1 = true;
      }, 300);
    },
  },
  components: {
    Modal,
  },
  methods: {
    /**
     * 文件上传
     */
    fileUpload1(el) {
      let files = el.target.files[0];
      if (!files) {
        ShowTip(this.$t("mall.请上传文件"), "danger");
        return;
      }
      this.fileObj1 = "";
      this.filePath1 = "";
      this.loading = true;
      $.api_call(
        "api.SupplierMallConfig.uploadWxcert",
        {
          "@file": files,
          wxFileName: "key",
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("mall.上传文件成功"), "success");
            this.fileObj1 = el.target.files[0];
            this.filePath1 = el.target.value;
            this.configInfo.paymentJson.W.keyUrl = 1;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    /**
     * 文件上传
     */
    fileUpload(el) {
      let files = el.target.files[0];
      if (!files) {
        ShowTip(this.$t("mall.请上传文件"), "danger");
        return;
      }
      this.fileObj = "";
      this.filePath = "";
      this.loading = true;
      $.api_call(
        "api.SupplierMallConfig.uploadWxcert",
        {
          "@file": files,
          wxFileName: "cert",
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("mall.上传文件成功"), "success");
            this.configInfo.paymentJson.W.certUrl = 1;
            this.fileObj = el.target.files[0];
            this.filePath = el.target.value;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    addNewGroup() {
      $("#modalGroup").modal("show");
      this.getGroupList();
    },
    getGroupList() {
      this.checkedArr = [];
      $.api_call("api.UserGroup.findBySupplier", {}, (r) => {
        if (r.ErrorCode == "9999") {
          this.groupLi = r.Data.Results;
          if (!this.groupLi.length) return;
          this.configInfo.memberJsonSet.forEach((e) => {
            this.groupLi.forEach((s) => {
              if (e.groupId == s.id) {
                this.checkedArr.push(e.groupId);
              }
            });
          });
          this.checkedArr = Array.from(new Set(this.checkedArr));
        } else {
          if (r.ErrorCode == "1002") {
            userFailure();
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    selectProvince() {
      this.city = 0;
      this.area = undefined;
      this.cityArr = [];
      this.areaArr = [];
      let p = this.province;
      if (this.selectCityArr[p] && this.selectCityArr[p].sub) {
        this.cityArr = this.selectCityArr[p].sub;
      } else {
        this.cityArr = [];
      }
    },
    selectCity() {
      this.area = undefined;
      let c = this.city;
      if (!c) return;
      if (this.cityArr[c].sub) {
        this.areaArr = this.cityArr[c].sub;
      } else {
        this.areaArr = [];
      }
    },
    addNewSite(type) {
      switch (type) {
        case "site":
          this.configInfo.webSiteJsonSet.push({
            name: "",
            edit: true,
          });
          break;
        case "qq":
          this.configInfo.serviceJsonSet.push({
            name: "",
            value: "",
            edit: true,
          });
          break;
        default:
          break;
      }
    },
    getConfig() {
      this.loading = true;
      $.api_call("api.SupplierMallConfig.getConfig", {}, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.configInfo = r.Data.Results;
          if (this.configInfo.paymentJson && this.configInfo.paymentJson.Z) {
            this.$set(this.configInfo.paymentJson.Z, "edit", false);
          }
          if (this.configInfo.paymentJson && this.configInfo.paymentJson.W) {
            this.$set(this.configInfo.paymentJson.W, "edit", false);
          }
          let arr = [];
          if (
            this.configInfo.webSiteJson &&
            this.configInfo.webSiteJson.length
          ) {
            this.configInfo.webSiteJson.forEach((e) => {
              arr.push({
                name: e,
                edit: false,
              });
            });
          }
          this.$set(this.configInfo, "webSiteJsonSet", arr);

          let arr2 = [];
          if (
            this.configInfo.serviceJson &&
            this.configInfo.serviceJson.length
          ) {
            this.configInfo.serviceJson.forEach((e) => {
              arr2.push({
                name: e.name,
                value: e.value,
                edit: false,
              });
            });
          }
          this.$set(this.configInfo, "serviceJsonSet", arr2);

          let arr3 = [];
          if (this.configInfo.memberJson && this.configInfo.memberJson.length) {
            this.configInfo.memberJson.forEach((e) => {
              this.$set(e, "allowVisit", e.allowVisit == 1 ? true : false);
              this.$set(e, "allowBuy", e.allowBuy == 1 ? true : false);
              this.$set(
                e,
                "allowShowPrice",
                e.allowShowPrice == 1 ? true : false
              );
              arr3.push(e);
            });
          }
          this.$set(this.configInfo, "memberJsonSet", arr3);

          if (this.configInfo.contactJson) {
            this.contact = this.configInfo.contactJson.contact
              ? this.configInfo.contactJson.contact
              : "";
            this.mobile = this.configInfo.contactJson.mobile
              ? this.configInfo.contactJson.mobile
              : "";
            this.qq = this.configInfo.contactJson.QQ
              ? this.configInfo.contactJson.QQ
              : "";
            this.wangwang = this.configInfo.contactJson.wangwang
              ? this.configInfo.contactJson.wangwang
              : "";

            this.address = this.configInfo.contactJson.address
              ? this.configInfo.contactJson.address
              : "";
            this.postCode = this.configInfo.contactJson.postCode
              ? this.configInfo.contactJson.postCode
              : "";
            this.cityArr = [];
            this.areaArr = [];
            if (this.configInfo.contactJson.province) {
              //$t('mall.选省')
              for (let i = 0; i < this.selectCityArr.length; i++) {
                if (
                  this.selectCityArr[i].name ==
                  this.configInfo.contactJson.province
                ) {
                  this.province = i;
                  this.selectProvince();
                  break;
                }
              }
            } else {
              this.province = 0;
            }

            if (this.configInfo.contactJson.city) {
              //$t('mall.选市')
              for (let i = 0; i < this.cityArr.length; i++) {
                if (this.cityArr[i].name == this.configInfo.contactJson.city) {
                  this.city = i;
                  if (i > 0) this.selectCity();
                  break;
                }
              }
            } else {
              this.city = 0;
            }

            if (this.configInfo.contactJson.area) {
              //$t('mall.选区')
              for (let i = 0; i < this.areaArr.length; i++) {
                if (this.areaArr[i].name == this.configInfo.contactJson.area) {
                  this.area = i;
                  break;
                }
              }
            } else {
              this.area = undefined;
            }
          }

          this.configInfoCopy = JSON.parse(JSON.stringify(this.configInfo));
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    remove(type, i) {
      switch (type) {
        case "site":
          this.configInfo.webSiteJsonSet.splice(i, 1);
          break;
        case "qq":
          this.configInfo.serviceJsonSet.splice(i, 1);
          break;
        default:
          break;
      }
      this.editSave(type, i);
    },
    editSave(type, i) {
      let params = {};
      switch (type) {
        case "police":
          if (!this.configInfo.policeRecord) {
            ShowTip(this.$t("mall.请填写公安备案"), "danger");
            return;
          }
          params.policeRecord = this.configInfo.policeRecord;
          break;
        case "ipc":
          if (!this.configInfo.ipcRecord) {
            ShowTip(this.$t("mall.请填写IPC备案"), "danger");
            return;
          }
          params.ipcRecord = this.configInfo.ipcRecord;
          break;
        case "name":
          if (!this.configInfo.mallName) {
            ShowTip(this.$t("mall.请填写店铺名称"), "danger");
            return;
          }
          params.mallName = this.configInfo.mallName;
          break;
        case "site": {
          let num1 = 0;
          params.webSiteJson = [];
          this.configInfo.webSiteJsonSet.forEach((e) => {
            if (!e.name) {
              num1++;
            }
            params.webSiteJson.push(e.name);
          });
          if (num1 > 0) {
            ShowTip(this.$t("mall.请填写站点域名"), "danger");
            return;
          }
          break;
        }
        case "toggle":
          params.openRegister = this.configInfo.openRegister == 1 ? 2 : 1;
          break;
        case "qq": {
          let num = 0;
          params.serviceJson = [];
          this.configInfo.serviceJsonSet.forEach((e) => {
            if (!e.name) {
              num++;
            }
            params.serviceJson.push({
              name: e.name,
              value: e.value,
            });
          });
          if (num > 0) {
            ShowTip(this.$t("mall.请填写QQ"), "danger");
            return;
          }
          break;
        }
        case "member":
          params.memberJson = [];
          this.configInfo.memberJsonSet.forEach((e) => {
            params.memberJson.push({
              groupId: e.groupId,
              allowVisit: e.allowVisit ? 1 : 2,
              allowBuy: e.allowBuy ? 1 : 2,
              allowShowPrice: e.allowShowPrice ? 1 : 2,
            });
          });
          break;
        case "memberAdd": {
          params.memberJson = [];
          let arr = [];
          this.configInfo.memberJsonSet.forEach((e, i) => {
            if (i < 2) {
              arr.push(e);
            }
          });
          if (this.checkedArr.length == 0) {
            this.configInfo.memberJsonSet = arr;
          } else {
            this.groupLi.forEach((e) => {
              this.checkedArr.forEach((s) => {
                if (e.id == s) {
                  this.configInfo.memberJsonSet = arr;
                  this.configInfo.memberJsonSet.push({
                    groupId: e.id,
                    name: e.name,
                    allowVisit: true,
                    allowBuy: true,
                    allowShowPrice: true,
                  });
                }
              });
            });
          }
          this.configInfo.memberJsonSet.forEach((e) => {
            params.memberJson.push({
              groupId: e.groupId,
              allowVisit: e.allowVisit ? 1 : 2,
              allowBuy: e.allowBuy ? 1 : 2,
              allowShowPrice: e.allowShowPrice ? 1 : 2,
            });
          });
          break;
        }
        case "contact":
          if (
            !this.contact &&
            !this.mobile &&
            !this.qq &&
            !this.wangwang &&
            !this.address &&
            !this.province &&
            !this.city &&
            !this.area &&
            !this.postCode
          ) {
            ShowTip(this.$t("mall.请填写联系信息"), "danger");
            return;
          }
          params.contactJson = {
            contact: this.contact,
            mobile: this.mobile,
            QQ: this.qq,
            wangwang: this.wangwang,
            address: this.address,
            postCode: this.postCode,
            // 省份
            province: this.province
              ? this.selectCityArr[this.province].name
              : undefined,
            provinceId: this.province
              ? this.selectCityArr[this.province].key
              : undefined,
            // 城市
            city: this.city ? this.cityArr[this.city].name : undefined,
            // 区域
            area:
              this.area || this.area === 0
                ? this.areaArr[this.area].name
                : undefined,
          };
          break;
        case "payZ":
          // 支付宝信息
          params.paymentJson = {};
          params.paymentJson.Z = {
            appId: this.configInfo.paymentJson.Z.appId,
            privateKey: this.configInfo.paymentJson.Z.privateKey,
            publicKey: this.configInfo.paymentJson.Z.publicKey,
          };
          params.paymentJson.W = {
            appId: this.configInfo.paymentJson.W.appId,
            appKey: this.configInfo.paymentJson.W.appKey,
            certUrl: this.configInfo.paymentJson.W.certUrl,
            keyUrl: this.configInfo.paymentJson.W.keyUrl,
            merchantId: this.configInfo.paymentJson.W.merchantId,
          };
          break;
        case "payW":
          // 微信支付信息
          params.paymentJson = {};
          params.paymentJson.Z = {
            appId: this.configInfo.paymentJson.Z.appId,
            privateKey: this.configInfo.paymentJson.Z.privateKey,
            publicKey: this.configInfo.paymentJson.Z.publicKey,
          };
          params.paymentJson.W = {
            appId: this.configInfo.paymentJson.W.appId,
            appKey: this.configInfo.paymentJson.W.appKey,
            certUrl: this.configInfo.paymentJson.W.certUrl,
            keyUrl: this.configInfo.paymentJson.W.keyUrl,
            merchantId: this.configInfo.paymentJson.W.merchantId,
          };
          break;
        default:
          break;
      }
      params.id = this.configInfo.id ? this.configInfo.id : 0;
      this.loading = true;
      $.api_call("api.SupplierMallConfig.addConfig", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("mall.保存成功"), "success");
          this.getConfig();
          switch (type) {
            case "police":
              this.editPolice = false;
              break;
            case "ipc":
              this.editIpc = false;
              break;
            case "name":
              this.editName = false;
              break;
            case "site":
              if (this.configInfo.webSiteJsonSet[i]) {
                this.configInfo.webSiteJsonSet[i].edit = false;
              }
              break;
            case "qq":
              this.configInfo.serviceJsonSet[i].edit = false;
              break;
            case "contact":
              this.editContact = false;
              break;
            case "memberAdd":
              $("#modalGroup").modal("hide");
              break;
            default:
              break;
          }
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    edit(type, i) {
      this.configInfoCopy = JSON.parse(JSON.stringify(this.configInfo));
      switch (type) {
        case "police":
          this.editPolice = true;
          break;
        case "ipc":
          this.editIpc = true;
          break;
        case "name":
          this.editName = true;
          break;
        case "site":
          this.configInfo.webSiteJsonSet[i].edit = true;
          break;
        case "qq":
          this.configInfo.serviceJsonSet[i].edit = true;
          break;
        case "pay":
          this.editPay = true;
          break;
        case "contact":
          this.editContact = true;
          break;
        case "sqq":
          this.editSqq = true;
          break;
        case "payZ":
          this.$set(this.configInfo.paymentJson.Z, "edit", true);
          this.configInfo.paymentJson.Z.edit = true;
          break;
        case "payW":
          this.$set(this.configInfo.paymentJson.W, "edit", true);
          break;
        default:
          break;
      }
    },
    editCancel(type, i) {
      // 修改时恢复一下默认值
      this.configInfo = JSON.parse(JSON.stringify(this.configInfoCopy));
      switch (type) {
        case "police":
          this.editPolice = false;
          break;
        case "ipc":
          this.editIpc = false;
          break;
        case "name":
          this.editName = false;
          break;
        case "site":
          this.configInfo.webSiteJsonSet[i].edit = false;
          if (this.configInfo.webSiteJsonSet[i].name == "") {
            this.remove(type, i);
          }
          break;
        case "qq":
          this.configInfo.serviceJsonSet[i].edit = false;
          if (
            this.configInfo.serviceJsonSet[i].name == "" &&
            this.configInfo.serviceJsonSet[i].value == ""
          ) {
            this.remove(type, i);
          }
          break;
        case "pay":
          this.editPay = false;
          break;
        case "contact":
          this.editContact = false;
          this.getConfig();
          break;
        case "sqq":
          this.editSqq = false;
          break;
        case "payZ":
          this.configInfo.paymentJson.Z.edit = false;
          break;
        case "payW":
          this.configInfo.paymentJson.W.edit = false;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped="scoped">
.list-body {
  align-items: center;
  padding: 5px;
  margin-bottom: 5px;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.show-white-style .list-body {
  border: none;
}
.show-white-style .list-body:nth-child(2n) {
  background: #e9ecef;
  margin-bottom: 2px;
}
.show-white-style .list-body:nth-child(2n + 1) {
  background: #f6f6f6;
  margin-bottom: 2px;
}
</style>
